import { acceptOnlyValidOptionByValue } from '../../field-viewer/shared-normalizers';
export const eventsRsvpViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByValue
};

//# sourceMappingURL=definition-viewer.js.map